import { AccountController } from "@/app/ui/controllers/AccountController";
import moment from "moment";
import getCurrentAccountTimezone from "./GetCurrentAccountTimezone";
import { configDates } from "./modules/Date";

const TIMEZONE_PATTERN = /^(?:GMT)?([+-])(\d{1,2}):?(\d{2})$/;

const getUtcOffset = (timezone: string): string => {
  const timezoneParts = timezone.match(TIMEZONE_PATTERN);
  if (!timezoneParts) return "+0000";
  const [, sign, hours, minutes] = timezoneParts;
  return `${sign}${hours.padStart(2, "0")}${minutes}`;
};

const formatDateBasedAccountTimezone = (
  date: string,
  format = "DD MMMM YYYY, HH:mm",
  withoutTimeZone = false
): string => {
  if (!date) return "";
  const timezone = getCurrentAccountTimezone();
  const formattedDate = moment(new Date(date))
    .utcOffset(getUtcOffset(timezone))
    .format(format);
  const locale = AccountController.accountData.countryCode || "id";
  const timezoneLabel = configDates(timezone)[locale.toLowerCase()];
  return timezoneLabel && !withoutTimeZone
    ? `${formattedDate} ${timezoneLabel}`
    : formattedDate;
};

export default formatDateBasedAccountTimezone;
